import chat from '@services/chat/chat.reducer';
import family from '@services/family/family.reducer';
// import holidays from '@services/holidays/holidays.reducer';
import logs from '@services/log/log.reducer';
import schedule from '@services/schedule/schedule.reducer';
import event from '@services/events/event.reducer';
import todo from '@services/todos/todo.reducer';
import suggestion from '@services/suggestion/suggestion.reducer';
import user from '@services/user/user.reducer';
import connection from '@services/user/connection.reducer';
import calls from '@services/calls/call.reducer';
import file from '@services/file/file.reducer';
import article from '@services/article/article.reducer';
import articleViewer from '@services/article/articleViewer.reducer';
import expert from '@services/expert/expert.reducer';
import offer from '@services/offer/offer.reducer';
import subscriptions from '@services/subscription/subscription.reducer';
import rating from '@services/rating/rating.reducer';
import notes from '@services/sharednote/sharednote.reducer';
import posts from '@services/imageflow/imageflow.reducer';
import economy from '@services/economy/economy.reducer';
import externalCalendar from "@services/externalCalendar/externalCalendar.reducer"
import ui from '@services/ui/ui.reducer';
import accountLink from '@services/accountLink/accountLink.reducer';
import { combineReducers } from 'redux';
import { RESET_APP, RESET_EXCEPT_SESSION, IPreservedUserBits  } from '@services/reset';

const appReducer = combineReducers({
  event,
  todo,
  chat,
  family,
  logs,
  calls,
  schedule,
  suggestion,
  user,
  connection,
  file,
  article,
  articleViewer,
  expert,
  offer,
  subscriptions,
  rating,
  notes,
  posts,
  economy,
  externalCalendar,
  ui,
  accountLink,
});

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
  if (action.type === RESET_APP) {
    state = undefined; // full drop to initial
    console.log('Resetting entire app state.');
  } else if (action.type === RESET_EXCEPT_SESSION) {
    const { session, appToken }: IPreservedUserBits = action.payload;
    console.log('Resetting app state except session.');
    // Build a fresh initial tree, then overwrite preserved user bits.
    const initial = appReducer(undefined, { type: '@@INIT' });
    return {
      ...initial,
      user: {
        ...initial.user,
        session,
        appToken,
      },
    } as typeof initial;
  }
  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducer.ts